// extracted by mini-css-extract-plugin
module.exports = {"logo":"_ea853b4"};